import React, { useState } from "react";
import Layout from "../Layout/Layout";
import SettingsTabs from "../Components/SettingComponents/SettingSidebar";
import Profile from "../Components/SettingComponents/Profile";
import TermsAndConditions from "../Components/SettingComponents/TermsAndConditions";
import PrivacyPolicy from "../Components/SettingComponents/PrivacyPolicy";
import Faqs from "../Components/SettingComponents/Faq";
import Notifications from "../Components/SettingComponents/Notification";
import Guidelines from "../Components/SettingComponents/Guidelines";
import ChangePassword from "../Components/SettingComponents/ChangePassword";
import ContactUs from "../Components/SettingComponents/ContactUs";
import DeleteAccount from "../Components/SettingComponents/DeleteAccount";

export default function Settings() {
  const [currentTab, setCurrentTab] = useState("profile");

  const onTabChange = (tab) => {
    setCurrentTab(tab.id);
  };
  const components = {
    profile: <Profile />,
    "terms-and-conditions": <TermsAndConditions />,
    "privacy-policy": <PrivacyPolicy />,
    faqs: <Faqs />,
    notifications: <Notifications />,
    "community-guidelines": <Guidelines></Guidelines>,
    "change-password": <ChangePassword />,
    "contact-us": <ContactUs />,
    "delete-account": <DeleteAccount />,
  };

  const render = components[currentTab];

  return (
    <Layout showHeader={false}>
      <div className="page-content h-100">
        <div className="setting-content">
          <div className="d-flex align-items-center gap-2 pages-title-container">
            <img
              alt="image-alt"
              className="sidebar-toggle"
              src="/icons/menu.svg"
            />
            <h1 className="pages-header text-heading-h2 mb-0">Settings</h1>
          </div>

          <div className="setting-card">
            <SettingsTabs onTabChange={onTabChange} currentTab={currentTab} />
            <hr className="setting-vertical-line" />
            <div className="tab-content setting-tab-content">{render}</div>
          </div>
        </div>
      </div>

      {/* delete account modal  */}
      <div
        className="modal delete-account-modal fade"
        id="deleteAccountModal"
        tabIndex="-1"
        aria-labelledby="deleteAccountModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title text-heading-h3">Delete Account?</h1>
            </div>
            <hr className="modal-hr" />
            <div className="modal-body">
              <p className="text-body-b2 mb-0">
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
                commodo ligula eget dolor massa. Cum sociin natoque penatibus et
                magnis dis parturient montes, nascetur ridiculus mus. Donec quam
                felis.
              </p>
              <div className="d-flex gap-3 mt-3 mt-sm-4 justify-content-center delete-modal-btn-container">
                <button
                  className="btn-1 btn-1-primary px-3 text-body-b1"
                  style={{
                    maxWidth: "182px",
                    width: "100%",
                    background: "#d65858",
                  }}
                >
                  Confirm Delete
                </button>
                <button
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  className="btn-1 btn-1-basic px-3 text-body-b1"
                  style={{ maxWidth: "166px", width: "100%" }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
